const TeacherEmail = () => {
    // console.log(localStorage.getItem('teacher'))
    return localStorage.getItem('teacher')
    //return "t0_10.5.2021_e16f610666f6480eba915fa7f09e2893@gmail.com"
}

export { TeacherEmail };
